// removed by extract-text-webpack-plugin
    if(module.hot) {
      // 1789455991453
      var cssReload = require("!../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  


//////////////////
// WEBPACK FOOTER
// ./config/module-publish/resources/css/main.less
// module id = 414
// module chunks = 1